export default "__VITE_ASSET__CbxGwpVO__"